import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NonAuthGuard  {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(): boolean {
    if (this.auth.isAuthenticated()) {
        this.router.navigateByUrl('/home');
        return false;
    }
    return true;
  }
}
